import { render } from "./ShipmentLabelPreview.vue?vue&type=template&id=77102268&ts=true"
import script from "./ShipmentLabelPreview.vue?vue&type=script&lang=ts"
export * from "./ShipmentLabelPreview.vue?vue&type=script&lang=ts"

import "./ShipmentLabelPreview.vue?vue&type=style&index=0&id=77102268&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__